// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"e8be3242","200":"5a7e439f","323":"93910e8c","453":"a8eed47b","660":"a3e39ff1"}[chunkId] + ".chunk.js";
};